import React, { useState } from "react";
import myImage from "../img/contact-us.jpg";
import bgmap from "../images/background/bg-map.png";
import axios from "axios";
import Select from "react-select"; // Import React Select
import "../css/contact.css";

function Contact() {
  const [formData, setFormData] = useState({
    enquiry: [],
    name: "",
    mobile: "",
    email: "",
    city: "",
    pincode: "",
    message: "",
  });

  const [formErrors, setFormErrors] = useState({});
  const [responseMessage, setResponseMessage] = useState("");
  const enquiryOptions = [
    { value: "LED_lights", label: "LED Lights" },
    { value: "Lithium_Battery", label: "Lithium Battery" },
    { value: "Inverter_And_UPS", label: "Inverter & UPS" },
    { value: "Metal_Engineering_Profile", label: "Metal Engineering Profile" },
    { value: "other", label: "Other" },
  ];

  const validateForm = () => {
    let errors = {};
    if (!formData.name.trim()) errors.name = "Name is required";
    if (!formData.mobile.match(/^[6-9]\d{9}$/))
      errors.mobile = "Enter a valid 10-digit mobile number starting with 6-9";
    if (!formData.email.match(/^\S+@\S+\.\S+$/))
      errors.email = "Enter a valid email address";
    if (!formData.city.trim()) errors.city = "City is required";
    if (!formData.pincode.match(/^\d{6}$/))
      errors.pincode = "Enter a valid 6-digit pincode";
    if (!formData.message.trim()) errors.message = "Message is required";
    if (formData.enquiry.length === 0)
      errors.enquiry = "Please select at least one enquiry type";
    setFormErrors(errors);
    return Object.keys(errors).length === 0;
  };

  const handleChange = (e) => {
    const { name, options, value } = e.target;

    if (name === "enquiry") {
      const selectedValues = Array.from(options)
        .filter((option) => option.selected)
        .map((option) => option.value);
      setFormData({ ...formData, [name]: selectedValues });
    } else {
      setFormData({ ...formData, [name]: value });
    }
  };
  const handleEnquiryChange = (selectedOptions) => {
    const selectedValues = selectedOptions
      ? selectedOptions.map((option) => option.value)
      : [];
    setFormData({ ...formData, enquiry: selectedValues });
  };
  const handleSubmit = async (e) => {
    e.preventDefault();

    // Call validation before submission
    if (!validateForm()) {
      return; // Stop submission if validation fails
    }

    try {
      const response = await axios.post(
        `${process.env.REACT_APP_BASE_Backend_URL}/contact/contactsubmit`,
        formData
      );
      setResponseMessage(response.data.message);
      setFormData({
        enquiry: [],
        name: "",
        mobile: "",
        email: "",
        city: "",
        pincode: "",
        message: "",
      });
      setFormErrors({}); 
    } catch (error) {
      setResponseMessage("Error submitting the form. Please try again.");
    }
  };

  return (
    <div className="page-content">
      {/* INNER PAGE BANNER */}
      <div
        className="sx-bnr-inr overlay-wraper bg-parallax bg-top-center"
        data-stellar-background-ratio="0.5"
        style={{ backgroundImage: `url(${myImage})` }}
      >
        <div className="overlay-main bg-black opacity-07" />
        <div className="container">
          <div className="sx-bnr-inr-entry">
            <div className="banner-title-outer">
              <div className="banner-title-name">
                <h2 className="m-tb0">Contact Us</h2>
                <p>Get in touch with us today for personalized assistance.</p>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* CONTACT FORM */}
      <div className="section-full p-tb80 inner-page-padding">
        <div className="container">
          <div className="section-content">
            <div className="row">
              <div className="col-lg-8 col-md-12 col-sm-12">
                <form
                  className="contact-form cons-contact-form bg-gray p-a30"
                  onSubmit={handleSubmit}
                >
                  {responseMessage && (
                    <p className="response-message">{responseMessage}</p>
                  )}

                  <div className="contact-one">
                    <div className="section-head">
                      <div className="sx-separator-outer separator-left">
                        <div className="sx-separator bg-white bg-moving bg-repeat-x">
                          <h3 className="sep-line-one">Contact Us</h3>
                        </div>
                      </div>
                    </div>

                    <div className="form-group">
                      <label>Select Enquiry Type</label>
                      <Select
                        isMulti
                        name="enquiry"
                        options={enquiryOptions}
                        className="basic-multi-select"
                        classNamePrefix="select"
                        onChange={handleEnquiryChange}
                        value={enquiryOptions.filter((option) =>
                          formData.enquiry.includes(option.value)
                        )}
                        placeholder="Select enquiry types..."
                      />
                      {formErrors.enquiry && (
                        <span className="error">{formErrors.enquiry}</span>
                      )}
                    </div>

                    <div className="form-group">
                      <input
                        name="name"
                        type="text"
                        required
                        className="form-control"
                        placeholder="Name"
                        value={formData.name}
                        onChange={handleChange}
                      />
                      {formErrors.name && (
                        <span className="error">{formErrors.name}</span>
                      )}
                    </div>

                    <div className="form-group">
                      <input
                        name="mobile"
                        type="tel"
                        className="form-control"
                        required
                        placeholder="Mobile Number"
                        value={formData.mobile}
                        onChange={handleChange}
                      />
                      {formErrors.mobile && (
                        <span className="error">{formErrors.mobile}</span>
                      )}
                    </div>

                    <div className="form-group">
                      <input
                        name="email"
                        type="email"
                        className="form-control"
                        required
                        placeholder="Email"
                        value={formData.email}
                        onChange={handleChange}
                      />
                      {formErrors.email && (
                        <span className="error">{formErrors.email}</span>
                      )}
                    </div>

                    <div className="form-group">
                      <input
                        name="city"
                        type="text"
                        required
                        className="form-control"
                        placeholder="City"
                        value={formData.city}
                        onChange={handleChange}
                      />
                      {formErrors.city && (
                        <span className="error">{formErrors.city}</span>
                      )}
                    </div>

                    <div className="form-group">
                      <input
                        name="pincode"
                        type="text"
                        required
                        className="form-control"
                        placeholder="Pincode"
                        value={formData.pincode}
                        onChange={handleChange}
                      />
                      {formErrors.pincode && (
                        <span className="error">{formErrors.pincode}</span>
                      )}
                    </div>

                    <div className="form-group">
                      <textarea
                        name="message"
                        rows={4}
                        className="form-control"
                        required
                        placeholder="Message"
                        value={formData.message}
                        onChange={handleChange}
                      />
                      {formErrors.message && (
                        <span className="error">{formErrors.message}</span>
                      )}
                    </div>

                    <div className="text-right">
                      <button
                        name="submit"
                        type="submit"
                        className="site-button btn-half"
                      >
                        <span>Submit</span>
                      </button>
                    </div>
                  </div>
                </form>
              </div>

              {/* CONTACT INFO SECTION */}
              <div className="col-lg-4 col-md-12 col-sm-12">
                <div
                  className="contact-info block-shadow bg-white bg-center p-a40"
                  style={{ backgroundImage: `url(${bgmap})` }}
                >
                  <div>
                    <div className="section-head">
                      <div className="sx-separator-outer separator-left">
                        <div className="sx-separator bg-white bg-moving bg-repeat-x">
                          <h3 className="sep-line-one">Contact Info</h3>
                        </div>
                      </div>
                    </div>
                    <div className="sx-icon-box-wraper left p-b30">
                      <div className="icon-xs">
                        <i className="fa fa-phone" />
                      </div>
                      <div className="icon-content">
                        <h5 className="m-t0">Phone number</h5>
                        <p>+91 97780-44000, 97785-44000</p>
                      </div>
                    </div>

                    <div className="sx-icon-box-wraper left p-b30">
                      <div className="icon-xs">
                        <i className="fa fa-envelope" />
                      </div>
                      <div className="icon-content">
                        <h5 className="m-t0">Email address</h5>
                        <p>sales@spinoff.in</p>
                      </div>
                    </div>

                    <div className="sx-icon-box-wraper left">
                      <div className="icon-xs">
                        <i className="fa fa-map-marker" />
                      </div>
                      <div className="icon-content">
                        <h5 className="m-t0">Corporate Office</h5>
                        <p>SCO-117/118, Sec-43B, Chandigarh-160022</p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* GOOGLE MAP */}
      <iframe
        src="https://www.google.com/maps/embed?pb=!1m14!1m8!1m3!1d13721.3065930351!2d76.6931899!3d30.7092162!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x390feeff34a1a62b%3A0x4cdbc1aa576f2c91!2sSpinoff%20Technopark%20Pvt%20Ltd!5e0!3m2!1sen!2sin!4v1723268717290!5m2!1sen!2sin"
        width="100%"
        height={450}
        style={{ border: 10 }}
        allowFullScreen=""
        loading="lazy"
        referrerPolicy="no-referrer-when-downgrade"
      />
    </div>
  );
}

export default Contact;
